// Utils
import randomString from '../../common/uid/randomString';
import { getTimestamp } from '../../common/utils/timeUtil';
import { createTimestamp } from '../../common/uid/timestamp';

export const createSessionId = (): string => `msid-${createTimestamp(getTimestamp())}${randomString(5)}`;
